module.exports = __webpack_public_path__ + "static/media/create-boost-app-file.d1485224.gif";